"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _Paragraph = require("../../../elements/Paragraph/Paragraph");
var _excluded = ["children"];
var _templateObject;
var StyledMarkdownList = (0, _styledComponents.default)(_Paragraph.BaseParagraph)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n"])), function (props) {
  return props.bfTextColor ? _bfBaseStyles.colorMappings[props.bfTextColor] : "black";
});
var BasicList = function BasicList(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(StyledMarkdownList, props, _react.default.createElement("ul", props, children));
};
var _default = BasicList;
exports.default = _default;